module.exports = {"659011400":"新星市核心区","659011500":"兵团红星一场","659011501":"红星四场","659011502":"黄田农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659011.json
// module id = 3303
// module chunks = 0